import { KnownNavigationTypes } from "./generateAtoNStyle";

export const getAtonIcon = (
  type: KnownNavigationTypes,
  hasLighting: boolean,
  hasFault: boolean,
): string => {
  const black = "#000";
  const lightVisible = hasLighting ? 1 : 0;
  const faultVisible = hasFault ? 1 : 0;
  let halfsVisible = 0;
  let bottomHalfColor = black;
  let topHalfColor = black;
  let thirdsVisible = 0;
  let middleColor = black;
  let topBottomThirdColor = black;
  let fullBodyVisible = 0;
  let squareVisible = 0;
  let triangleLowerVisible = 0;
  let triangleLowerDownVisible = 0;
  let triangleUpperVisible = 0;
  let triangleUpperDownVisible = 0;
  let crossVisible = 0;
  let triangleColor = black;
  let color = "#ee3e34";
  switch (type) {
    case "Vasen":
      fullBodyVisible = 1;
      squareVisible = 1;
      color = "#ee3e34";
      break;
    case "Oikea":
      color = "#03a785";
      fullBodyVisible = 1;
      triangleLowerVisible = 1;
      triangleColor = color;
      break;
    case "Pohjois":
      color = "#faf034";
      halfsVisible = 1;
      topHalfColor = black;
      bottomHalfColor = color;
      triangleLowerVisible = 1;
      triangleUpperVisible = 1;
      triangleColor = black;
      break;
    case "Etelä":
      color = "#faf034";
      halfsVisible = 1;
      topHalfColor = color;
      bottomHalfColor = black;
      triangleLowerDownVisible = 1;
      triangleUpperDownVisible = 1;
      triangleColor = black;
      break;
    case "Itä":
      color = "#faf034";
      thirdsVisible = 1;
      topBottomThirdColor = black;
      middleColor = color;
      triangleLowerDownVisible = 1;
      triangleUpperVisible = 1;
      triangleColor = black;
      break;
    case "Länsi":
      color = "#faf034";
      thirdsVisible = 1;
      topBottomThirdColor = color;
      middleColor = color;
      triangleLowerVisible = 1;
      triangleUpperDownVisible = 1;
      triangleColor = black;
      break;
    case "Erikoismerkki":
      color = "#faf034";
      fullBodyVisible = 1;
      crossVisible = 1;
      break;
    default:
      break;
  }
  const svgCode = `<svg width="34.361874mm" height="61.164921mm" viewBox="0 0 34.361874 61.164921" version="1.1" id="svg1062"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:svg="http://www.w3.org/2000/svg">
  <defs id="defs1059" />
  <g id="layer1" transform="translate(-139.53491,-70.018181)">
     <path style="opacity:1;fill:${color};stroke-width:0.713225" d="m 145.77091,112.92239 a 0.98872429,0.98872429 0 0 1 -0.98873,0.98873 0.98872429,0.98872429 0 0 1 -0.98872,-0.98873 0.98872429,0.98872429 0 0 1 0.98872,-0.98872 0.98872429,0.98872429 0 0 1 0.98873,0.98872 z" id="inner-circle" />
     <path style="opacity:1;stroke-width:1.05833" d="m 147.69384,112.11051 h 2.55598 v 1.45841 h -2.55598 z" id="right-stub" />
     <path style="stroke-width:1.05833" d="m 139.53491,112.11056 h 2.55597 v 1.45841 h -2.55597 z" id="left-stub" />
     <path style="fill:${color};fill-opacity:${lightVisible};fill-rule:nonzero;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="m 152.58876,116.66012 c 1.43186,0.43948 4.29526,1.31834 7.77533,2.36732 3.48006,1.04898 7.57663,2.26803 9.85173,3.147 2.2751,0.87897 2.72869,1.41761 3.04048,1.96338 0.31178,0.54577 0.48188,1.09859 0.56689,1.63015 0.085,0.53155 0.085,1.04185 0.0566,1.43873 -0.0284,0.39687 -0.0851,0.68038 -0.22683,1.04889 -0.14176,0.36851 -0.36857,0.82211 -0.69456,1.21187 -0.32599,0.38975 -0.75123,0.71578 -1.2048,0.9851 -0.45357,0.26932 -0.93552,0.48194 -1.42451,0.60953 -0.489,0.1276 -0.98512,0.17012 -1.59463,0.0497 -0.6095,-0.12042 -1.33243,-0.40392 -1.91362,-0.69448 -0.5812,-0.29056 -1.02062,-0.58823 -1.59474,-1.04182 -0.57411,-0.4536 -1.28286,-1.06312 -2.60118,-2.23968 -1.31833,-1.17656 -3.24612,-2.92008 -5.30864,-4.73454 -2.06252,-1.81446 -4.25964,-3.69973 -5.3725,-4.69906 -1.11285,-0.99932 -1.14118,-1.11271 -1.09156,-1.21212 0.0496,-0.0994 0.17719,-0.18445 0.24094,-0.22696 0.0638,-0.0425 0.0637,-0.0425 1.49557,0.39698 z" id="light" />
     <path style="opacity:${fullBodyVisible};fill:${color};stroke:none;stroke-width:0.489724" d="m 172.2196,29.560886 h 4 v 26.043288 h -4 z" transform="rotate(19.49975)" id="body-full" />
     <path style="opacity:${halfsVisible};fill:${bottomHalfColor};stroke:none;stroke-width:0.489724" d="m 172.2196,42.582529 4,10e-7 v 13.021644 h -4 z" transform="rotate(19.49975)" id="body-lower-half" />
     <path style="opacity:${thirdsVisible};fill:${topBottomThirdColor};stroke:none;stroke-width:0.489724" d="m 172.22,46.9231 4,-10e-5 -4e-4,8.681174 h -4 z" transform="rotate(19.49975)" id="body-lower-third" />
     <path style="opacity:${thirdsVisible};fill:${middleColor};stroke:none;stroke-width:0.489724" d="m 172.22,38.242 h 4 v 8.681 l -4,10e-5 z" transform="rotate(19.49975)" id="body-middle-third" />
     <path style="opacity:${thirdsVisible};fill:${topBottomThirdColor};stroke:none;stroke-width:0.489724" d="m 172.22,29.5609 h 4 v 8.6811 h -4 z" transform="rotate(19.49975)" id="body-upper-third" />
     <path style="opacity:${halfsVisible};fill:${topHalfColor};stroke:none;stroke-width:0.489724" d="m 152.47408,85.352738 3.77058,1.335211 -4.34666,12.274759 -3.77057,-1.335211 z" id="body-upper-half" />
     <path style="opacity:1;stroke-width:0.698719" transform="rotate(19.49975)" d="m 173.7196,27.276833 h 1 v 2.284053 h -1 z" id="neck" />
     <path style="opacity:${squareVisible};fill:${color};stroke:${black};stroke-width:0.505912" transform="rotate(19.49975)" d="m 171.2196,22.276833 h 6 v 5 h -6 z" id="top-square" />
     <path style="opacity:${triangleLowerVisible};fill:${triangleColor};stroke:${black};stroke-width:2" d="M 81.226555,33.91989 106.22156,8.9248894 115.37036,43.068696 Z" id="top-triangle-lower" transform="matrix(0.20030942,0.01610749,-0.01610749,0.20030942,136.05173,74.573184)" />
     <path style="opacity:${triangleLowerDownVisible};fill:${triangleColor};stroke:${black};stroke-width:0.401912" d="m 160.53036,79.26289 -5.40935,4.604127 -1.28262,-6.98669 z" id="top-triangle-lower-down" />
     <path style="opacity:${triangleUpperVisible};fill:${triangleColor};stroke:${black};stroke-width:0.401912" d="m 154.227,75.937748 5.40934,-4.604128 1.28262,6.986691 z" id="top-triangle-upper" />
     <path id="top-triangle-upper-down" style="opacity:${triangleUpperDownVisible};fill:${triangleColor};stroke:${black};stroke-width:0.401912" d="m 162.98232,72.524902 -5.40934,4.604128 -1.28262,-6.98669 z" />
     <path style="opacity:1;fill:none;stroke:${black};stroke-width:0.49;stroke-miterlimit:4;stroke-dasharray:none" d="m 172.2196,29.560886 h 4 v 26.043288 h -4 z" transform="rotate(19.49975)" id="body-outlines" />
     <path style="opacity:1;fill:none;stroke:${black};stroke-width:1.05833" d="m 147.55231,112.92239 a 2.7701287,2.7701287 0 0 1 -2.77013,2.77013 2.7701287,2.7701287 0 0 1 -2.77013,-2.77013 2.7701287,2.7701287 0 0 1 2.77013,-2.77012 2.7701287,2.7701287 0 0 1 2.77013,2.77012 z" id="outer-circle" />
     <path style="color:${black};opacity:${crossVisible};fill:${color};stroke-width:0.49;stroke:${black};stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none" d="m 155.32386,78.317852 -1.6792,0.733453 1.07157,2.057259 -2.24657,0.981274 0.80095,1.537699 2.24656,-0.981273 1.07158,2.057259 1.67919,-0.733453 -1.07157,-2.057259 2.24657,-0.981274 -0.80095,-1.537699 -2.24656,0.981273 z" id="special-cross" />
     <path id="alert" style="opacity:${faultVisible};fill:#d92a2f;stroke:none;stroke-width:0.925346;stroke-opacity:1" d="m 162.33702,102.70972 h -1.83629 v -4.590727 h 1.83629 m 0,8.263317 h -1.83629 v -1.83629 h 1.83629 m -11.01776,4.59073 h 20.19923 L 161.41888,91.691962 Z" />
     <path style="opacity:${faultVisible};fill:none;stroke:#000000;stroke-width:0.422959;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 160.50073,104.54602 v 1.83629 h 1.83629 v -1.83629 z" id="alert-dot-outline" />
     <path style="opacity:${faultVisible};fill:none;stroke:#000000;stroke-width:0.422959;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 160.50073,98.118993 h 1.83629 v 4.590727 h -1.83629 z" id="alert-exclamation-outline" />
     <path style="opacity:${faultVisible};fill:none;fill-opacity:1;stroke:#000000;stroke-width:0.422959;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 161.41888,91.691964 10.09961,17.444786 h -20.19923 z" id="alert-outline" />
  </g>
</svg>`;
  const atonIcon = `data:image/svg+xml;base64,${window.btoa(svgCode)}`;
  return atonIcon;
};
